
import { Vue, Component, Prop } from "vue-property-decorator";
import { User, NumberStake } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { startCase, sumBy, uniq, uniqBy } from "lodash";
import { customMoment } from "@/main";
import { queries } from "@/apollo";
import * as legacyApollo from "@/apollo/legacySmartQuery";
import { formatCount } from "@/helpers/formatCount";

@Component({
  mixins: [legacyApollo.legacySmartQueries({
    numberStakes: {
      query: queries.numberStakes,
      skip() {
        return !this.startReleaseDate || !this.number || !this.userId;
      },
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          releaseDate: customMoment(this.startReleaseDate)
            .startOf("day")
            .toDate(),
          appMode: "DD",
          behalfOf: this.userId,
          number: this.number
        };
      }
    }
  })],
})
export default class NumberStakeModal extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop({ required: true }) startReleaseDate!: Date;
  @Prop({ required: true }) userId!: User["userId"];
  @Prop({ required: true }) number!: string;

  numberStakes = null as null | NumberStake[];

  formatDollar = formatDollar;
  startCase = startCase;
  formatCount = formatCount;

  get summary() {
    if (!this.numberStakes) {
      return null;
    }
    return {
      numberCount: this.numberStakes.length,
      in: {
        big: sumBy(this.numberStakes, s => s.in.big),
        small: sumBy(this.numberStakes, s => s.in.small),
        amount: sumBy(this.numberStakes, s => s.in.amount)
      },
      intake: {
        big: sumBy(this.numberStakes, s => s.intake.big),
        small: sumBy(this.numberStakes, s => s.intake.small),
        amount: sumBy(this.numberStakes, s => s.intake.amount)
      },
      toCompany: {
        big: sumBy(this.numberStakes, s => s.toCompany.big),
        small: sumBy(this.numberStakes, s => s.toCompany.small),
        amount: sumBy(this.numberStakes, s => s.toCompany.amount)
      }
    };
  }

  formatDate(date: string) {
    return customMoment(date).format("DD MMM YYYY");
  }
  formatDatetime(date: string) {
    return customMoment(date).format("DD/MMM HH:mm:ss");
  }

  toggleModal(val: boolean) {
    this.$emit("input", val);
  }
}
